export const getOrder = (index: number, currentIndex: number, length: number) => {
  const shift = 1 - currentIndex;
  if (shift === 0) return index;

  const order = index + shift;
  if (order < 0) return length + order;
  if (order === length) return 0;
  return order;
};
